/** @file Emits one triangle with a colour per vertex on the white page (heatmaps interpolate across it). */
import type { Sink } from './createSink';
import { emitMesh, type PixelMesh } from './emitMesh';

const TRI = [0, 1, 2];
/** The primitive, refilled per call (no object per triangle). */
const mesh: PixelMesh = { page: 0, count: 3, xy: TRI, uv: null, light: 0, lights: TRI, indices: TRI };

/** `xy` = 6 pixel numbers; `lights` = 3 packed colours, one per vertex. */
export function emitTriangle(sink: Sink, xy: ArrayLike<number>, lights: ArrayLike<number>): void {
  mesh.page = sink.white;
  mesh.xy = xy;
  mesh.lights = lights;
  emitMesh(sink, mesh);
}
